import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HttpClient } from '@angular/common/http';
import { AppModule } from './app.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Cookie, CookieBrowser } from './shared/cookie.service';
import { REQUEST } from '@nguniversal/express-engine/tokens';

import * as Raven from 'raven-js';

export function requestFactory(): any {
  return { cookie: document.cookie };
}

if (environment.production == true)
{
  Raven
    .config('https://bd01e3ef33a34ec39eb2885486bfabb2@sentry.io/1368496', { release: environment.PACKAGE_VERSION })
    .install();
}

@NgModule({
  imports: [
    BrowserModule.withServerTransition({appId: 'cityss-front'}),     
    AppModule,
    BrowserTransferStateModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    })
  ],
  providers: [{provide: Cookie, useClass: CookieBrowser},
    {
      provide: REQUEST,
      useFactory: requestFactory
    } ],
  bootstrap: [AppComponent]
})
export class AppBrowserModule { }


export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http,'./assets/i18n/','.json?_v_='+environment.APP_VERSION);
}